import { render, staticRenderFns } from "./GestionamientosEquipos.vue?vue&type=template&id=bd13999e&scoped=true&"
import script from "./GestionamientosEquipos.vue?vue&type=script&lang=js&"
export * from "./GestionamientosEquipos.vue?vue&type=script&lang=js&"
import style0 from "./GestionamientosEquipos.vue?vue&type=style&index=0&id=bd13999e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd13999e",
  null
  
)

export default component.exports